export var DxpPageType;
(function (DxpPageType) {
    DxpPageType["REAL"] = "real page";
})(DxpPageType || (DxpPageType = {}));
export var DxpDataLayerEvent;
(function (DxpDataLayerEvent) {
    DxpDataLayerEvent["CONFIGURATOR"] = "Configurator";
    DxpDataLayerEvent["CHECKOUT"] = "Checkout";
})(DxpDataLayerEvent || (DxpDataLayerEvent = {}));
export var DxpDataLayerEventNames;
(function (DxpDataLayerEventNames) {
    DxpDataLayerEventNames["CONFIGURATOR_ENTRY"] = "CNF_EntryPoint";
    DxpDataLayerEventNames["CONFIGURATOR_MODEL"] = "CNF_ModelClicked";
    DxpDataLayerEventNames["CONFIGURATOR_MOTOR"] = "CNF_MotorClicked";
    DxpDataLayerEventNames["CONFIGURATOR_VERSIONS"] = "CNF_VersionsClicked";
    DxpDataLayerEventNames["CONFIGURATOR_EXTERIOR"] = "CNF_ExteriorColorsClicked";
    DxpDataLayerEventNames["CONFIGURATOR_INTERIOR"] = "CNF_InteriorColorsClicked";
    DxpDataLayerEventNames["CONFIGURATOR_ACCESSORIES"] = "CNF_AccessoriesClicked";
    DxpDataLayerEventNames["CONFIGURATOR_CALCULATE_BUTTON"] = "CNF_CalculateButtonClicked";
    DxpDataLayerEventNames["CONFIGURATOR_TEST_DRIVE"] = "CNF_TestDriveClicked";
    DxpDataLayerEventNames["CHECKOUT_LEAD_QUOTE"] = "CNF_LeadQuote";
    DxpDataLayerEventNames["CONFIGURATOR_QUOTE"] = "CNF_QuoteClicked";
    DxpDataLayerEventNames["CNF_DEALERS_CLICKED"] = "CNF_DealersClicked";
    DxpDataLayerEventNames["PAGE_VIEW"] = "page_view ";
    DxpDataLayerEventNames["VEHICLE_SELECTION_DETAILS"] = "checkout_your_vehicle_selection_details";
    DxpDataLayerEventNames["BEGIN_CHECKOUT"] = "begin_checkout";
    DxpDataLayerEventNames["BACK_CTA_CLICK"] = "checkout_reservation_details_back_cta_click";
    DxpDataLayerEventNames["DETAILS_CTA_CLICK"] = "checkout_edit_your_reservation_details_cta_click";
    DxpDataLayerEventNames["CONFIGURATION_CTA_CLICK"] = "checkout_open_your_configuration_cta_click";
    DxpDataLayerEventNames["FINANCE_CTA_CLICK"] = "checkout_purchase_option_finance_cta_click";
    DxpDataLayerEventNames["PURCHASE_OPTION_NEXT_CTA_CLICK"] = "checkout_purchase_option_next_cta_click";
    DxpDataLayerEventNames["PRODUCTS_CTA_CLICK"] = "checkout_select_additional_products_cta_click";
    DxpDataLayerEventNames["ADDITIONAL_PRODUCTS_CTA_CLICK"] = "checkout_additional_products_next_cta_click";
    DxpDataLayerEventNames["RETAILER_DETAILS_CTA_CLICK"] = "checkout_select_retailer_details_cta_click";
    DxpDataLayerEventNames["RETAILER_CONFIRM_DETAILS_CTA_CLICK"] = "checkout_confirm_retailer_details_cta_click";
    DxpDataLayerEventNames["ADD_SHIPPING_INFO"] = "add_shipping_info";
    DxpDataLayerEventNames["TRADEIN_CTA_CLICK"] = "checkout_add_vehicle_trade_in_cta_click";
    DxpDataLayerEventNames["TRADEIN_NO_CTA_CLICK"] = "checkout_trade_in_no_cta_click";
    DxpDataLayerEventNames["TRADEIN_BRAND_CTA_CLICK"] = "checkout_trade_in_brand_cta_click";
    DxpDataLayerEventNames["TRADEIN_MODEL_CTA_CLICK"] = "checkout_trade_in_model_cta_click";
    DxpDataLayerEventNames["TRADEIN_MILEAGE_CTA_CLICK"] = "checkout_trade_in_mileage_cta_click";
    DxpDataLayerEventNames["TRADEIN_REGISTRATION_NUMBER_CTA_CLICK"] = "checkout_trade_in_add_registration_number_cta_click";
    DxpDataLayerEventNames["TRADEIN_DATE_OF_REGISTRATION_CTA_CLICK"] = "checkout_trade_in_date_of_registration_cta_click";
    DxpDataLayerEventNames["TRADEIN_DETAILS_CTA_CLICK"] = "checkout_submit_trade_in_details_cta_click";
    DxpDataLayerEventNames["TNC_PRIVACY_CTA_CLICK"] = "checkout_checkbox_tnc_privacy_cta_click";
    DxpDataLayerEventNames["CONFIRM_RESERVATION_CTA_CLICK"] = "checkout_reservation_details_confirm_reservation_cta_click";
    DxpDataLayerEventNames["ADD_PAYMENT_INFO"] = "add_payment_info";
    DxpDataLayerEventNames["ORDER_CONFIRMED"] = "checkout_vehicle_order_confirmed";
    DxpDataLayerEventNames["PURCHASE"] = "purchase";
    DxpDataLayerEventNames["CONFIGURATOR_URL_CTA_CLICK"] = "checkout_copy_configurator_url_cta_click";
})(DxpDataLayerEventNames || (DxpDataLayerEventNames = {}));
export var DataLayerDXPProducts;
(function (DataLayerDXPProducts) {
    DataLayerDXPProducts["FINANCE_CALCULATOR"] = "Finance Calculator";
    DataLayerDXPProducts["CHECKOUT"] = "Checkout";
    DataLayerDXPProducts["ALTSPC"] = "Alt SPC";
})(DataLayerDXPProducts || (DataLayerDXPProducts = {}));
export var DataLayerEvent;
(function (DataLayerEvent) {
    DataLayerEvent["FORM_NAVIGATE"] = "_formNavigate";
    DataLayerEvent["FORM_INTERACT"] = "_formInteract";
})(DataLayerEvent || (DataLayerEvent = {}));
export var DataLayerFormName;
(function (DataLayerFormName) {
    DataLayerFormName["CONFIGURATOR"] = "configurator";
    DataLayerFormName["REPAYMENT_CALCULATOR"] = "repayment calculator";
    DataLayerFormName["FINANCE_APPLICATION"] = "configurator_finance_enquiry";
    DataLayerFormName["CONFIGURATOR_STOCK_RESERVATION"] = "configurator_stock_reservation";
})(DataLayerFormName || (DataLayerFormName = {}));
export var DataLayerFormStage;
(function (DataLayerFormStage) {
    DataLayerFormStage["CATALOG"] = "catalog";
    DataLayerFormStage["CONTINUE_CHECKOUT"] = "continue";
    DataLayerFormStage["CONFIGURE_CAR"] = "configure your car";
    DataLayerFormStage["VARIANT_CONFIGURATOR"] = "variant";
    DataLayerFormStage["PAYMENT_DISPLAY"] = "payment method displayed";
    DataLayerFormStage["CHECKOUT"] = "checkout";
    DataLayerFormStage["START"] = "start";
    DataLayerFormStage["FA_START"] = "start";
    DataLayerFormStage["FA_SUBMITTED"] = "submitted";
    DataLayerFormStage["CHECKOUT_CONFIRMATION"] = "enquire submitted";
    DataLayerFormStage["DEALER"] = "enquire select retailer";
    DataLayerFormStage["SELECT_DEALER"] = "select dealer";
    DataLayerFormStage["ENQUIRY_FORM"] = "enquire customer information";
    DataLayerFormStage["CUSTOMER_INFORMATION"] = "customer information";
    DataLayerFormStage["PAYMENT_METHOD"] = "payment_method";
    DataLayerFormStage["EMAIL_MY_CONFIGURATION_SUBMITTED"] = "email my configuration submitted";
    DataLayerFormStage["FINALISE_TRANSACTION"] = "finalise transaction";
})(DataLayerFormStage || (DataLayerFormStage = {}));
export var DesignType;
(function (DesignType) {
    DesignType["INTERIOR"] = "subaru_interior";
    DesignType["SUBARU_EXTERIOR"] = "subaru_colour";
})(DesignType || (DesignType = {}));
export var FormFieldName;
(function (FormFieldName) {
    FormFieldName["COLOR"] = "colour";
    FormFieldName["SPECKPACK"] = "specPack";
    FormFieldName["LOANTERM"] = "loan term";
})(FormFieldName || (FormFieldName = {}));
//# sourceMappingURL=customDataLayerTypes.js.map